import React from "react";
import { Box, Typography } from "@mui/material";
import CustomTextField from "./common/CustomTextField";
import { COLORS } from "../assets/theme";

interface CombinedFieldProps {
  label?: string;
  labelValue1: string | number;
  placeholder1?: string;
  value1?: string | number;
  onChange1?: (value: string) => void;
  editable1?: boolean;
  placeholder2: string;
  translatedSenderId: string;
  onTranslatedValueChange: (value: string) => void;
  error1?: boolean;
  helperText1?: string;
  error2?: boolean;
  helperText2?: string;
  showLabel?: boolean;
}

const CustomCombinedField: React.FC<CombinedFieldProps> = ({
  label,
  labelValue1,
  placeholder1,
  value1,
  onChange1,
  editable1 = false,
  placeholder2,
  translatedSenderId,
  onTranslatedValueChange,
  error1,
  helperText1,
  error2,
  helperText2,
  showLabel = true, 
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      {showLabel && (
        <Typography
          variant="body1"
          sx={{ marginBottom: 1, fontWeight: "bold", color: "#333" }}
        >
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1, sm: 0 },
          alignItems: "center",
          width: "100%",
        }}
      >
        {editable1 ? (
          <CustomTextField
            placeholder={placeholder1}
            value={value1}
            onChange={(e) => onChange1?.(e.target.value)}
            error={error1}
            helperText={helperText1}
            fullWidth
            sx={{
              flex: 1,
              backgroundColor: COLORS.WhiteBackground,
              borderTopRightRadius: { xs: 12, sm: 0 },
              borderBottomRightRadius: { xs: 12, sm: 0 },
              borderRadius: { xs: 2, sm: 0 },
              mb: { xs: 1, sm: 0 },
              "& .MuiOutlinedInput-root": {
                borderTopRightRadius: { xs: 12, sm: 0 },
                borderBottomRightRadius: { xs: 12, sm: 0 },
                marginRight: { xs: 0, sm: "-1px" },
              },
            }}
          />
        ) : (
          <Box
            sx={{
              flex: 1,
              backgroundColor: COLORS.WhiteBackground,
              border: "1px solid #ccc",
              borderRadius: { xs: 2, sm: "12px 0 0 12px" },
              padding: "10px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#333",
              fontSize: "14px",
              fontWeight: 400,
              mb: { xs: 1, sm: 0 },
            }}
          >
            {labelValue1}
          </Box>
        )}

        <CustomTextField
          placeholder={placeholder2}
          value={translatedSenderId}
          onChange={(e) => {
            const newValue = e.target.value;
            onTranslatedValueChange(newValue);
          }}
          error={error2}
          helperText={helperText2}
          fullWidth
          sx={{
            backgroundColor: COLORS.WhiteBackground,
            borderTopLeftRadius: { xs: 12, sm: 0 },
            borderBottomLeftRadius: { xs: 12, sm: 0 },
            borderRadius: { xs: 2, sm: 0 },
            flex: 1,
            "& .MuiOutlinedInput-root": {
              borderTopLeftRadius: { xs: 12, sm: 0 },
              borderBottomLeftRadius: { xs: 12, sm: 0 },
              marginLeft: { xs: 0, sm: "-1px" },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomCombinedField;
